export const defaultUserGroups = ['user:pf', 'supervisor:pf'];
export const supervisorpfUserGroup = 'supervisor:pf';
export const supervisorGroupConstant = 'supervisor:';
export const userGroupConstant = 'user:';
